import DistributorLayout from '@/layouts/DistributorLayout.vue'

export default [
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/restricted/users/UserListView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_ACCOUNT_READ_PERMISSION'],
      menuSelected: 'users'
    }
  },
  {
    path: '/users/:accountId',
    name: 'userDetail',
    component: () => import('@/views/restricted/users/UserDetailLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_ACCOUNT_READ_PERMISSION'],
      menuSelected: 'users'
    }
  },
  {
    path: '/users/:accountId/edit',
    name: 'userUpdate',
    component: () => import('@/views/restricted/users/UserUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_ACCOUNT_UPDATE_PERMISSION'],
      menuSelected: 'users'
    }
  },
  {
    path: '/users/:accountId/collaborators/create',
    name: 'userCollaboratorCreate',
    component: () => import('@/views/restricted/users/UserCollaboratorView.vue'),
    props: { mode: 'create' },
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_ADD_COLLABORATOR'],
      menuSelected: 'users'
    }
  },
  {
    path: '/users/:accountId/collaborators/:collaboratorId/edit',
    name: 'userCollaboratorUpdate',
    component: () => import('@/views/restricted/users/UserCollaboratorView.vue'),
    props: { mode: 'edit' },
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_UPDATE_COLLABORATOR'],
      menuSelected: 'users'
    }
  }
]
